export default __webpack_public_path__ + "static/media/3381.f30b6b93.png";